var Firerest = require('firerest');

const api = Firerest.create({
  api: spat.config.api.endpoint,
  debug: spat.config.env !== 'production',
});

api.constant = Firerest.create({
  api: spat.config.constants_api.endpoint,
  debug: spat.config.env !== 'production',
});

api.on('prefetch', async (ref) => {
  var user = app.auth.currentUser;
  if (user) {
    var token = await user.getIdToken(true);
    ref.headers({
      Authorization: `Bearer ${token}`,
    });
  }
});

api.on('success', (ref) => {
  if (spat.isBrowser && /^\/app\/.*\/projects\/[^\/]+/.test(location.pathname)) {
    const matched = new URL(ref.api).pathname.match(/\/companies\/([^\/]+)\/projects\/([^\/]+)/);
    if (!matched) return;
    const company_id = matched[1];
    const project_id = matched[2];
    if (!project_id || !company_id) return;
    // localStorage に last seen をsetする
    app.utils.setLastSeenItem({ company_id, project_id });
  }
});

api.on('fail', function (req, res) {
  if (!spat.isBrowser) {
    return;
  }

  if (res.status === 401) {
    if (spat.router.current !== '/signin') {
      spat.router.push('/signin');
    }
  }
});

export default api;
